import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Optional, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { TranslateModule } from '@ngx-translate/core';
import { AccessibleClickDirective } from '@shared/shared/directives/accessible-click.directive';
import { Observable } from 'rxjs';
import { PayWithPointsComponent } from '../pay-with-points/pay-with-points.component';

@Component({
  selector: 'ten-pay-with-points-popup',
  templateUrl: './pay-with-points-popup.component.html',
  styleUrls: ['./pay-with-points-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    PayWithPointsComponent,
    CommonModule,
    AccessibleClickDirective,
  ],
})
export class PayWithPointsPopupComponent {
  @Input() public showDescription = false;
  @Input() public showCurrencyEquivalent = false;
  @Input() public displayNote = false;
  @Input() public points: number;
  @Input() public fiatAmount: number;
  @Input() public fiatCurrency: string;
  @Output() public closed = new EventEmitter<void>();

  public displayNote$: Observable<boolean>;

  constructor(@Optional() private dialogRef: MatDialogRef<PayWithPointsPopupComponent>) {}

  public onClose() {
    this.dialogRef?.close();
    this.closed.emit();
  }
}
